module.exports = __webpack_public_path__ + "static/media/soyabeans.90245fed.png";